enum ReportingActions {
  RECEIVE_AGGREGATE_ARRIVALS = 'GENERATE_AGGREGATE_ARRIVALS',
}

export default ReportingActions;
